import {types} from './types';

const setGetListMessangerAction = (payload) => {
    return {
        type: types.SET_LIST_MESSANGER,
        payload,
      }
}

const setGetViewMessangerAction = (payload) => {
  return {
    type: types.SET_VIEW_MESSANGER,
    payload
  }
}
export {
  setGetListMessangerAction,
  setGetViewMessangerAction
}
